import React, { Component } from 'react';
import { Card, message, Modal, Table } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';

import util from '@util/index';

import { queryFilePreview } from '@api/pub/attachment';
import { queryRelateAddress } from '@api/incubator/oregistapp';

import DescriptionList from '@comm/DescriptionList';
import ComAddressSelect from '../contract/comm/ComAddressSelect';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      dataItem: this.props.data,
      addressesList: this.props.data ? JSON.parse(JSON.stringify(this.props.data.addresses)) : [],
    };
  }

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleAddressChange = uuids => {
    this.uuids = uuids;
  };

  handleSetAddress = () => {
    const { dataItem } = this.state;
    this.setState({ loading: true });
    queryRelateAddress({
      uuid: dataItem.uuid,
      addressUuids: this.uuids,
    })
      .then(res => {
        if (res.statusCode === 200) {
          this.props.getInfo();
          this.handleVisible(false);
        } else {
          message.error(res.message);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    const {
      dataItem,
      dataItem: { settleds, currentSettled },
    } = this.state;
    if (!settleds.some(item => item.uuid === currentSettled.uuid)) {
      currentSettled.isCurrent = true;
      settleds.push(currentSettled);
    }
    this.setState({
      dataItem,
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      data,
      data: { settleds, currentSettled },
    } = nextProps;

    if (!settleds.some(item => item.uuid === currentSettled.uuid)) {
      currentSettled.isCurrent = true;
      settleds.push(currentSettled);
    }

    this.setState({
      dataItem: data,
    });
  }

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.businessUuid}/info`}>
            {record.isTransfer ? <span style={{ color: '#fd7e14' }}>转</span> : null}
            {text}
          </Link>
        ),
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.deadline ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.deadline / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '交易类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{record.price ? '收费注册' : '免费注册'}</span>;
        },
      },
      {
        title: '合同金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '推荐人员',
        dataIndex: 'recommend',
        key: 'recommend',
        render: (text, record) => {
          return (
            <span>
              {text}
              <span style={{ marginLeft: '10px' }}>{record.recommendTel}</span>
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'isCurrent',
        key: 'isCurrent',
        render: (text, record) => {
          return <span>{text ? '当前关联' : '历史关联'}</span>;
        },
      },
    ];
  };

  render() {
    const {
      loading,
      visible,
      dataItem,
      addressesList,
      dataItem: { addresses, files, settleds = [] },
    } = this.state;
    return (
      <div className="form-open mb16">
        <Card title="地址注册详情">
          <DescriptionList size="large" col={3}>
            <Description term="孵化器">{dataItem.incubator}</Description>
            <Description term="公司名称">{dataItem.custom}</Description>
            <Description term="项目名称">{dataItem.projectName}</Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="地址数量">
              {dataItem.instance && dataItem.instance.status === 1 ? (
                <a onClick={this.handleVisible}>{dataItem.addressNum || '关联地址'}</a>
              ) : (
                <span>{dataItem.addressNum || '关联地址'}</span>
              )}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="注册地址">
              <div>
                {addresses.map(item => {
                  return <div key={item.url}>{item.name}</div>;
                })}
              </div>
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="关联基础孵化合同" />
            <Table
              rowKey="uuid"
              pagination={false}
              columns={this.columns()}
              dataSource={settleds}
            />
          </DescriptionList>

          <DescriptionList size="large" col={1} style={{ marginTop: '15px' }}>
            <Description term="附件">
              <div>
                {files.map(item => {
                  return (
                    <div key={item.url}>
                      <a onClick={() => queryFilePreview(item)}>{item.name}</a>
                    </div>
                  );
                })}
              </div>
            </Description>
          </DescriptionList>

          <DescriptionList size="large" col={1}>
            <Description term="入驻说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
        <Modal
          width={900}
          title="选择地址"
          visible={visible}
          confirmLoading={loading}
          onOk={this.handleSetAddress}
          onCancel={() => this.handleVisible(false)}
        >
          <ComAddressSelect
            incubatorUuid={dataItem ? dataItem.incubatorUuid : this.props.params.uuid}
            handleChange={this.handleAddressChange}
            addresses={addressesList}
          />
        </Modal>
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/incubator/oregistapp/FormOpen.js